export enum XhrReadyStateEnum {
  UnsentOrAborted = 0,
  Opened = 1,
  HeadersReceived = 2,
  Loading = 3,
  Done = 4,
}
